import * as React from 'react';

export const NotesTab = () => {
  return <div>TBA tab content: NotesTab</div>;
};
